import { render, staticRenderFns } from "./TareaEvolucion.vue?vue&type=template&id=55d2749a"
import script from "./TareaEvolucion.vue?vue&type=script&lang=js"
export * from "./TareaEvolucion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports